/**
 * Organizations Page Logic
 *
 * Admin organization management page
 */

import { initAuthenticatedPage, hasPermission } from '../app/init.js';
import { fillOrganizationsTable } from '../admin/organizations.js';
import { declareLoading, notificationDialog } from '../ui/dialogs.js';

/**
 * Initialize the organizations page
 */
export async function initOrganizationsPage(): Promise<void> {
  const user = await initAuthenticatedPage();
  if (!user) return; // Will redirect to login

  // Check admin permission
  if (!hasPermission('admin')) {
    notificationDialog('Access denied: Admin permission required');
    window.location.href = '/';
    return;
  }

  // Load organizations table
  declareLoading();
  try {
    await fillOrganizationsTable();
    // Show content after table is ready
    const content = document.getElementById('content');
    if (content) content.style.display = 'block';
  } catch (error) {
    const msg = error instanceof Error ? error.message : 'Failed to load organizations';
    notificationDialog(msg);
  }
}

// Export to window for onclick handlers
if (typeof window !== 'undefined') {
  (window as unknown as Record<string, unknown>).initOrganizationsPage = initOrganizationsPage;
}
